import React from 'react';
import { Link } from 'react-router-dom';

/**
 * SuccessPage — post-registration confirmation.
 *
 * Displayed after a successful registration.  Shows a thank-you message,
 * confirms that a welcome email has been sent, and provides links to
 * manage preferences or visit the XMPie Help Center.
 */
export default function SuccessPage() {
  return (
    <div className="page-container">
      <div className="form-card success-card">
        <div className="success-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#0d9e4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <h1>Registration Successful</h1>
        <p>
          Thank you for registering for XMPie Security Compliance notifications.
          You will now receive security updates for your selected products.
        </p>
        <p className="success-detail">
          A confirmation email has been sent to your registered email address.
          You can update your preferences at any time using the link provided in any notification email.
        </p>
        <div className="form-actions">
          <Link to="/preferences" className="btn-primary">Manage Preferences</Link>
          <a href="https://help.xmpie.com/" className="btn-secondary" target="_blank" rel="noopener noreferrer">
            Visit Help Center
          </a>
        </div>
      </div>
    </div>
  );
}
